import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $AppointmentCardContainer = styled('div')`
  margin-top: ${spacing('xxl')};
`;

export const $ExpectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing(10)} ${spacing('xl')};
  background: ${({ theme }) => theme.colors.secondaryColor2};
  border-radius: ${({ theme }) => theme.tw.radius.lg};

  & > * {
    width: 100%;
  }
  @media ${media.maxWidth.sm} {
    padding: ${spacing(10)} ${spacing(5)};
  }
  @media ${media.maxWidth.xs} {
    padding: unset;
  }
`;
